import React from "react";
import Footer from "../Footer/Footer.js";
import { Helmet } from "react-helmet-async";

import { InlineWidget } from "react-calendly";

const Schedule = (props) => {

  // console.log("Schedule:", props.context)

  const prefillData = {
    name: `${props.context.user.first_name} ${props.context.user.last_name}` ?? "",
    email: `${props.context.user.email}` ?? ""
  }

  const scanCart = () => {
    let link = ""
    const cart = props.context.cart
    if (cart.length > 0){
      // console.log("cart last item", cart[cart.length - 1])
      link = cart[cart.length -1].schedule_link //Set schedule link to last item in cart
    }

    return link
  }

  return (
    <div className="container-top" id="calendly">
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="description" content="It's A Good Life Fitness" />
        <title>It's A Good Life Fitness | Schedule</title>
        <link rel="canonical" href="https://itsagoodlifefitness.com" />
      </Helmet>
      <h1>Schedule Your Session</h1>
      {props.context.approved ? (
        <div className="widget">
          <InlineWidget url={scanCart()} prefill={prefillData}/>
        </div>
      ):(
        <div className="not-approved"><p>Schedule link cannot be found, please checkout first.</p></div>
      )}
      <Footer {...props}/>
    </div>
  );
};

export default Schedule;
